// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-o_fT","advertDetailHeaderLocation__value":"c-o_fU"};